export const ERROR = 'notif/error';
export const SUCCESS = 'notif/success';
export const CLEAR = 'notif/clear';
export const LOADING = 'notif/loading';
